/**
 * @file shared constants
 */

/**
 * stage report 阶段值
 */
export const StageReportStage = {
  APP_MOUNTED: 'app_mounted',
  PLUGIN_LOADED: 'plugin_loaded',
  PLUGIN_LOAD_ERROR: 'plugin_load_error',
};
